// extracted by mini-css-extract-plugin
module.exports = {"cameraContainer":"styles_cameraContainer__1tSuA","placeholder":"styles_placeholder__fCJjI","status":"styles_status__1Xjip"};